<template>
  <div id="digital-flop">
    <div
      class="digital-flop-item"
      v-for="item in digitalFlopData"
      :key="item.title"
    >
      <div class="digital-flop-title">{{ item.title }}</div>
      <div class="digital-flop">
        <dv-digital-flop
          :config="item.number"
          style="width:90px; height:45px;"
        />
          <div class="unit">{{ item.unit }}</div>
      </div>
    </div>

    <dv-decoration-10 />
  </div>
</template>

<script>
export default {
  name: 'DigitalFlop',
  data () {
    return {
      digitalFlopData: [],
      staticData: {},
      lineId: undefined
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  methods: {
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderStaticData',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      this.staticData = data;
      this.createData();
    },
    async createData () {
      this.digitalFlopData = [
        {
          title: '总站位数',
          number: {
            number: [this.staticData.totalStations],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold'
            }
          },
          unit: '站'
        },
        {
          title: '未上料',
          number: {
            number: [this.staticData.nonLoadedStations],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '站'
        },
        {
          title: '已上料',
          number: {
            number: [this.staticData.loadedStations],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '站'
        },
        {
          title: '已首检',
          number: {
            number: [this.staticData.firstInspection],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold'
            }
          },
          unit: '站'
        },
        {
          title: '核检次数',
          number: {
            number: [this.staticData.verifyFeedingTimes],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '次'
        },
        {
          title: '巡检次数',
          number: {
            number: [this.staticData.routingFeedingTimes],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '次'
        },
        {
          title: '手贴',
          number: {
            number: [this.staticData.handSticker],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '站'
        },
        {
          title: '空贴',
          number: {
            number: [this.staticData.emptySticker],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '站'
        },
        {
          title: '生产时长',
          number: {
            number: [this.staticData.productionDuration],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '小时'
        }
      ];
    }
  },
  mounted () {
    const { getBigScreen } = this;
    getBigScreen();
    setInterval(getBigScreen, 10000);
  }
}
</script>

<style lang="less">
#digital-flop {
  position: relative;
  width: 68%;
  height: 45%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(6, 30, 93, 0.3);

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 11%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);
  }

  .digital-flop-title {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }
}
</style>
